<ul [hidden]="isHidden">
  <li *ngFor="let error of errors" class="error">
    {{ error }}
  </li>
</ul>
